angular.module('aq.filters').filter('find', function() {

    return function(data, finder) {
        return _.find(data, finder);

    }
});